import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { flattenDeep as flatten } from 'lodash';
import { FETCH_FTTB_TV_CHANNELS_ERROR, FETCH_FTTB_TV_CHANNELS_START, FETCH_FTTB_TV_CHANNELS_SUCCESS, REMOVE_SELECTED_FTTB_TV_CHANNELS_PACKAGE, SET_SELECTED_FTTB_TV_CHANNELS_PACKAGE } from "../actions/actionTypes";
var reducers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FETCH_FTTB_TV_CHANNELS_START, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTvChannelsData: {
      state: 'loading'
    }
  });
}), FETCH_FTTB_TV_CHANNELS_SUCCESS, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTvChannelsData: _objectSpread(_objectSpread({}, state.fttbTvChannelsData), {}, {
      state: 'loaded',
      tvChannelsData: payload.tvChannelsData,
      tariffAlias: payload.tariffAlias,
      selectedTvPackages: []
    })
  });
}), FETCH_FTTB_TV_CHANNELS_ERROR, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTvChannelsData: {
      state: 'error'
    }
  });
}), SET_SELECTED_FTTB_TV_CHANNELS_PACKAGE, function (state, payload) {
  var tvPackagesGroups = state.fttbTvChannelsData.tvChannelsData.tvPackagesGroups;
  var allTvPackages = flatten(tvPackagesGroups.map(function (tvPackagesGroup) {
    return tvPackagesGroup.tvPackages;
  }));
  var tvPackages = payload.tvPackagesAliases.map(function (tvPackageAlias) {
    var selectedTvPackage = allTvPackages.find(function (tvPackage) {
      return tvPackage.alias === tvPackageAlias;
    });
    return {
      fee: selectedTvPackage.fee ? Number(selectedTvPackage.fee.value) : 0,
      alias: selectedTvPackage.alias,
      name: selectedTvPackage.name
    };
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTvChannelsData: _objectSpread(_objectSpread({}, state.fttbTvChannelsData), {}, {
      selectedTvPackages: tvPackages
    })
  });
}), REMOVE_SELECTED_FTTB_TV_CHANNELS_PACKAGE, function (state, _ref) {
  var alias = _ref.alias;
  var filtredTvPackages = state.fttbTvChannelsData.selectedTvPackages.filter(function (tvPackage) {
    return tvPackage.alias !== alias;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbTvChannelsData: _objectSpread(_objectSpread({}, state.fttbTvChannelsData), {}, {
      selectedTvPackages: filtredTvPackages
    })
  });
});
export var fttbTvChannelsData = function fttbTvChannelsData(state, action) {
  var reducer = reducers[action.type];
  return typeof reducer === 'function' ? reducer(state, action.payload) : state;
};